<template>
  <div class="card-block">
    <h4 class="card-title">
      Redeem Voucher
    </h4>
    <div class="row">
      <div class="col-md-6">
        <div class="bg-blue-grey-100 p-30">
          <p>If you have a redeem voucher code, please enter it below to receive your credit.</p>
          <form v-on:submit.prevent="onSubmitRedeemVoucher">
            <form-group>
              <input type="text" class="form-control" autocomplete="off" placeholder="Voucher Code" v-model="voucherCode">
            </form-group>
            <button type="submit" class="btn btn-primary">Redeem</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { Validator } from 'vee-validate';
import FormGroup from 'components/forms/FormGroup';

export default {
  components: {
    FormGroup,
  },
  props: {
    team: {
      type: Object,
    },
  },
  watch: {
    voucherCode: function() {
      if (this.formErrors.has('voucherCode')) {
        this.formErrors.remove('voucherCode');
      }
    },
  },
  computed: {
    ...mapGetters([
      'currentUser',
    ]),
  },
  data: function() {
    return {
      showAlert: false,
      validator: null,
      formErrors: null,
      errorResponse: null,
      successResponse: null,
      voucherCode: null,
    };
  },
  created: function() {
    this.isLoading = true;

    this.$emit('loadChanged', false);

    this.validator = new Validator();
    this.validator.attach('voucherCode', 'required', { prettyName: 'Voucher Code' });
    this.$set(this, 'formErrors', this.validator.errorBag);
  },
  methods: {
    onSubmitRedeemVoucher: function() {

    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// RedeemVoucher.vue?47e8962b